/**
 * Read the per-request CSP nonce from the `<meta property="csp-nonce">` tag
 * that TanStack Start emits when `router.options.ssr.nonce` is set.
 *
 * Used to forward the nonce explicitly to libraries that inject `<script>`
 * tags for cross-origin resources (Turnstile, etc.) — `'strict-dynamic'`
 * would normally cover them via the trust chain, but pairing it with an
 * explicit `nonce` attribute on the injected script is more robust.
 */
export function readCspNonce(): string | undefined {
  if (typeof document === "undefined") return undefined
  const value = document
    .querySelector('meta[property="csp-nonce"]')
    ?.getAttribute("content")
    ?.trim()
  return value ? value : undefined
}
